import React, { createContext } from 'react';

export const DashboardContext = createContext();
